document.addEventListener("DOMContentLoaded",()=>{

document.querySelectorAll("[data-product-id]").forEach(btn=>{

const id=btn.dataset.productId;

let items=JSON.parse(localStorage.getItem("wishlist")||"[]");

if(items.includes(id))
btn.classList.add("is-active");

btn.onclick=function(){

let items=JSON.parse(localStorage.getItem("wishlist")||"[]");

if(items.includes(id)){

items=items.filter(x=>x!=id);

btn.classList.remove("is-active");

}else{

items.push(id);

btn.classList.add("is-active");

}

localStorage.setItem("wishlist",JSON.stringify(items));

}

});

});